import { Banner, Button } from '../../../ds/components';
import { ApiError, errorMessage } from '../../../lib/api';

export interface LoadErrorProps {
  /** „Tickets konnten nicht geladen werden" — the sentence before the status and the server's message. */
  what: string;
  error: unknown;
  retrying: boolean;
  onRetry: () => void;
}

/** Load error in the pattern of Deal-Pipeline 15: danger banner with the status and „Erneut laden". */
export function LoadError({ what, error, retrying, onRetry }: LoadErrorProps) {
  const status = error instanceof ApiError ? error.status : null;
  return (
    <Banner
      tone="danger"
      actions={
        <Button variant="destructiveFilled" size="small" loading={retrying} onClick={onRetry}>
          Erneut laden
        </Button>
      }
    >
      {what}
      {status ? ` · Fehler ${status}` : ''}. {errorMessage(error)}
    </Banner>
  );
}

/** A 403 of the tickets routes (module off, no `tools.tickets`) shows the shell's locked page. */
export function isForbidden(error: unknown): boolean {
  return error instanceof ApiError && error.status === 403;
}
